
export default {
  isochronesDetails: {
    polygons: 'Polygone',
    center: 'Zentrum',
    reachCenters: 'Zentren erreichen',
    toggleVisibility: 'Sichtbarkeit umschalten',
    opacity: 'Opazität'
  }
}
